export default {
  send: 'Send',
  forward: 'Forward',
  OK: 'Confirm',
  cancel: 'Cancel',
  back: 'Back',
  addToOrder: 'Add to cart',
  updateProduct: 'Update order',
  chooseOptions: 'Order',

  banner: {
    title: 'Orders are closed',
    subtitle: 'We open for orders at {openingHour}',
    wait: 'Waiting time',
  },

  navigation: {
    phone: 's. 578 7874',
  },

  index: {
    reservation: 'Book a table',
    menu: 'View menu',
    locations: 'Our locations',
    menus: 'Menus',
    offers: 'View meals',
    openingHours: 'Opening hours',
  },

  catering: {
    title: 'Order here',
    previewTitle: 'See our selection',
    amount: 'Number of individuals',
    companyAmount: 'Number of trays',
    pricePerPerson: 'Price per individual',
    pricePerUnit: 'Price per tray',
    minQuantity: 'Minimum quantity',
    previewDisclaimer: 'Please visit saffran.is to order',
    order: 'Complete the order',
    deliveryMethod: 'Pick up or delivery?',
    paymentMethod: 'How would you want to pay?',
    company: 'Company catering',
    buffet: 'Buffet',
    submit: {
      errors: {
        title: 'Error',
        message: 'Please check if everything is filled out',
      },
    },
    content: {
      title: 'Catering service',
      line1: 'Is a party coming up?',
      line2: 'The mini burger trays are a fun and tasty change for the party table. Fifteen cold and cute burgers on each tray.',
      line3: 'Order no later than 13:00 on the next weekday before the delivery date. Note that orders for Fridays, Saturdays, Sundays, and Mondays must be received before 13:00 on the Thursday preceding that weekend.',
      ul: {
        li1: '15 burgers per tray',
        li2: 'Price per tray is 5.499 kr.',
        li3: 'Based on 3-5 burgers per person',
        li4: 'Order in advance',
      },
    },
    form: {
      title: 'Your order',
      login: 'Login',
      total: 'Total number:',
      trays: 'trays',
      totalItems: 'food for about {amount} people',
      price: 'Total price:',
      deliveryDate: 'When do you want to pick up?',
      deliveryTime: 'At what time do you want to pick up?',
      deliveryLocation: 'Pick up at',
      deliveryInfo: 'Your information',
      name: 'Name *',
      email: 'Email *',
      phone: 'Phone *',
      comment: 'Anything else you want to mention',
      submit: 'Finish order',
      errors: {
        name: 'Name must not be empty',
        phone: 'Phone number must not be empty',
      },
    },
  },
  kiosk: {
    cateringAd: {
      title: 'Planning a party?',
      description: 'Healthy and flavorful food for groups large and small. Delicious Saffran dishes served on beautiful platters. A guaranteed hit at meetings, parties, confirmations, weddings, birthdays, and all kinds of events',
    },
  },
  user: {
    authenticate: 'Login',
    logout: 'Logout',
    phoneNumber: 'Phone number',
    verificationCode: 'Verification code',
    fullname: 'Name on order',
    address: 'Address',
    postalCode: 'Postal code',
    validation: {
      name: 'Name must be at least 3 characters',
      address: 'Address is missing',
      postalCode: 'Postal code is missing',
    },
    addAddress: 'Add address',
    dialog: {
      logout: {
        title: 'Log out user',
        message: 'The user will be logged out and needs to log in again.',
        ok: 'Confirm',
        cancel: 'Cancel',
      },
    },
  },
  checkout: {
    hintPhoneNumber: 'Enter a phone number that can receive SMS. We will send you a code to confirm that you are the owner of the phone number.',
    hintVerificationCode: 'We have sent you a verification code via SMS. Confirm your phone number by entering it.',
    hintFullname: 'Confirm that the name on the order is correct.',
    hintAddress: 'Register an address for home delivery.',
  },
  payment: {
    locations: 'Location',
    methods: 'Payment method',
    header: 'Payment information',
    noDeliveryChosen: 'Choose how delivery will take place.',
    cardNumber: 'Card number',
    expiration: 'Expiry date',
    expirationMonth: 'Month',
    expirationYear: 'Year',
    ccv: 'Security code',
    cancel: 'Cancel',
    submitForm: 'Confirm payment information',
    hintPaymentData: 'The order will be paid by card with number ****-****-****-{lastFour}',
    phoneNumber: 'Phone number',
    secure3d: {
      hint: 'Click "Send" to start strong customer authentication (SCA) on the payment card.',
      submit: 'Send',
      cancel: 'Cancel',
      about: 'What is strong customer authentication (SCA)?',
    },
    valitorPage: {
      hint: "Click \"Send\" to pay on Valitor's payment page.",
      submit: 'Send',
      cancel: 'Cancel',
      footer: 'If you want to cancel or when payment is complete, it is safe to close the payment page to return.',
    },
    verifoneCheckout: {
      title: 'Pay for order',
      hint: "To pay for the order, a payment page from Verifone will now take over. After payment is received, the order will be processed by us. Click ”Continue” to pay on Verifone's payment page.",
      submit: 'Continue',
      cancel: 'Cancel',
      footer: 'If you want to cancel, or when payment is complete, it is safe to close the payment page to return.',
    },
    aur: {
      paymentPendingTitle: 'Payment pending',
      paymentPendingMessage: 'Finish paying through the Aur app to complete the order.',
    },
    validation: {
      cardNumber: {
        required: 'Card number is missing',
      },
      ccv: {
        required: 'Security number is missing',
      },
      expirationMonth: {
        required: 'Expiry date is missing',
      },
      expirationYear: {
        required: 'Expiry date is missing',
      },
      phoneNumber: {
        required: 'Phone number is missing',
        tooShort: 'Phone number is too short',
      },
    },
    errorFromPaymentService: 'Payment processor could not process payment.',
  },
  deliveryMethods: {
    deliveryMethods: 'Delivery',
    noDeliveryMethodAllowed: 'No delivery method available. The selected location may be closed.',
    deliveredAt: 'The order will be delivered to you at',
  },
  email: {
    contact: {
      title: 'Contact us',
      name: 'Name *',
      email: 'Email *',
      message: 'Message *',
      successDialog: {
        title: 'Email sent',
        message: 'Thank you for the message. We will be in touch if applicable.',
      },
    },
    application: {
      successDialog: {
        title: 'Email sent',
        message: 'Thank you for the application. We will be in touch.',
      },
    },
    errors: {
      name: 'Name must not be empty',
      email: 'Email must not be empty',
      message: 'Message must not be empty',
      emailInvalid: 'Email is in the wrong format',
      location: 'Location must not be empty',
    },
    buttons: {
      clear: 'Clear',
      submit: 'Send',
    },
    successDialog: {
      title: 'Email sent',
      message: '',
    },
  },
  product: {
    split: 'Split in half',
    firstHalf: 'First half',
    secondHalf: 'Second half',
    nutrition: {
      title: 'Nutritional values in the dish',
      carbs: 'Carbohydrates',
      fat: 'Fat',
      protein: 'Protein',
      kcal: 'kcal',
      regularDough: 'Saffran base',
      sourDough: 'Sourdough base',
    },
    allergens: 'Allergens in product',
  },
  category: {
    title: 'Menu',
    dialog: {
      title: 'Alcohol is only for 20+',
      message: 'Please confirm that you have reached that age. We reserve the right to ask for ID. Alcohol is not refunded.',
      ok: 'Yes',
      cancel: 'No',
    },
  },
  order: {
    footer: 'Your order',
    header: 'Your order',
    thankYou: 'Thank you for your order!',
    thankYouCateringDetails: 'The order will be produced and delivered on {delivered} in our branch at {location}',
    thankYouDetails: 'Your order has been received and will be ready in about {wait} minutes. Let us know at the counter when you arrive. Enjoy your meal!',
    thankYouDetailsOnSite: 'Your order has been received and will be ready in about {wait}  minutes. Get cutlery and a glass, find a free seat. We will call out the name on the order when it is ready. Enjoy your meal!',
    thankYouDetailsTakeAway: 'Your order has been received and will be ready in about {wait}  minutes. You can pick up your order at {location}. Enjoy your meal!',
    thankYouDetailsQR: 'The order will be ready soon. If you are interested in ordering more, you only need to scan the code again. Enjoy your meal.',
    isEmpty: 'You have not put anything in your order. View the menu and add to the order.',
    total: 'Total amount',
    discount: 'Discount',
    checkout: 'Complete order',
    confirm: 'Confirm order',
    productAdded: '{product} added to order',
    productUpdated: '{product} modified',
    removeFromOrder: 'Remove',
    editProduct: 'Edit',
    addProduct: 'Order',
    viewMenu: 'Back to menu',
    order: 'Order',
    coupon: 'Discount code',
    couponActivate: 'Activate coupon',
    customerSsn: 'Kennitala on receipt',
    viewCartItems: 'See items in cart',
    removeProduct: {
      title: 'Remove from order',
      message: '{product} will be removed from the order',
    },
    sendOrder: {
      title: 'Confirm order',
      message: 'After clicking confirm, the order is saved and processed.',
    },
  },
  location: {
    openingHours: 'Open today',
    openingDays: {
      weekdays: 'Mondays - Fridays',
      weekdaysShort: 'Mon - Fri',
      weekends: 'Saturdays and Sundays',
      weekendsShort: 'Sat and Sun',
      everyDay: 'Every day',
    },
    waitingTimes: {
      minutes: 'minutes',
      min: 'min',
    },
    closed: 'Orders are currently closed. Please try again within opening hours.',
    seeMore: 'See More',
  },
  date: {
    days: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    daysShort: [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat',
    ],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthsShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
  },
  footer: {
    openingHours: 'Open every day',
    user: 'User',
    home: 'Home',
    open: 'Open',
    copyright: 'All rights reserved',
    about: 'About',
    jobApplication: 'Job application',
  },

  application: {
    header: 'Apply for a job',
    name: 'Name *',
    ssn: 'Kennitala',
    email: 'Email *',
    phone: 'Phone number',
    message: 'Message *',
    location: 'Location being applied for *',
    cv: 'CV',
  },

  form: {
    months: {
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      mai: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December',
    },
    error: {
      invalidSsn: 'Invalid kennitala',
    },
  },
  errors: {
    default: {
      title: 'An error has occurred',
      message: 'Operation returned the error: {error}',
    },
    email: {
      title: 'Error',
      message: 'Could not send message. You can try again or send us an email directly at info@saffran.is',
    },
    code: {
      500: {
        title: 'Error from web service',
        message: 'Web service could not perform operation: "{error}"',
      },
      pilotErrorNoData: {
        title: 'Missing data',
        message: 'Order was not saved. Data was not correctly formatted: {error}',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Could not save order',
        message: '{error}',
      },
      pilotErrorOrderNotSaved: {
        title: 'Could not save order',
        message: '{error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Error in communication with payment service',
        message: 'Message from payment service: {error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Error in communication with payment service',
        message: 'Message from payment service: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Incorrect verification code',
        message: 'Check if it is entered correctly.',
      },
      pilotErrorCouponExpired: {
        title: 'Discount code expired',
        message: 'The code you provided is not active.',
      },
      pilotErrorCouponNotFound: {
        title: 'Discount code not found',
        message: 'Check if it is entered correctly.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Invalid card number',
        message: 'Check if you have provided the correct number.',
      },
      pilotErrorExpiredCard: {
        title: 'Card expiry date is expired',
        message: 'Try another card or another payment method.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Error in card number',
        message: 'Card number must be 11 to 19 digits',
      },
      pilotErrorOrderNotValid: {
        title: 'No order found',
        message: 'This can happen if the product selection changes.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'We cannot deliver "{product}"',
        message: 'You must choose another delivery method.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Minimum amount not reached',
        message: 'To choose this delivery method, you must order more.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Discount code not allowed',
        message: 'This discount code is not available for this delivery option.',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Incorrect pin number',
        message: 'Try again.',
      },
      couponNeedsDesktop: {
        title: 'Discount code not allowed',
        message: 'This discount code is only allowed on the web.',
      },
      couponNeedsCordova: {
        title: 'Discount code not allowed',
        message: 'This discount code is only allowed in the app.',
      },
      notAllowed: {
        title: 'Operation not performed',
        message: 'User does not have the required permissions.',
      },
      ECONNABORTED: {
        title: 'Connection timed out',
        message: 'Execution took an abnormally long time.',
      },
    },
    networkError: {
      title: 'Connection lost',
      message: 'Could not connect to services. Check if the device is connected to the internet.',
    },
  },
};
